import { z } from 'zod'

export const identifierSchema = z.object({
  email: z.string().min(1, 'Email is required').email('Invalid email address'),
})

export const passwordOnlySchema = z.object({
  password: z.string().min(1, 'Password is required'),
})

/** The identifier-first form collects these across two steps. */
export const loginSchema = identifierSchema.merge(passwordOnlySchema)

export type IdentifierSchemaType = z.infer<typeof identifierSchema>
export type PasswordOnlySchemaType = z.infer<typeof passwordOnlySchema>
export type LoginSchemaType = z.infer<typeof loginSchema>
